import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HallComponent } from './hall.component';
import { HallsService } from './halls.service';
import { ToolbarMode } from '@fuse/types/fuse-config';
// import { FooterComponent } from 'app/layout/components/footer/footer.component';
// import { NewsCarouselComponent } from 'app/layout/components/news-carousel/news-carousel.component';

export const routes: Routes = [
  {
    path: '',
    loadComponent:() => import('./hall-header/hall-header.component').then(m => m.HallHeaderComponent),
    outlet: 'hallHeaderOutlet',
  },
  {
    path: '',
    loadComponent:() => import('../../../layout/components/footer-wrapper/footer-wrapper.component').then(m => m.FooterWrapperComponent),
    outlet: 'footerOutlet',
  },
  // {
  //   path: '',
  //   component: NewsCarouselComponent,
  //   outlet: 'newsCarouselOutlet',
  // },
  {
    path: ':categorySlug',
    component: HallComponent,
    data: {
      isCacheable: true
    },
    children: [
      {
        path: '',
        data: {
          isCacheable: true,
          toolbarMode: ToolbarMode.transparent
        },
        loadChildren: () => import('./parent-hall/parent-hall.module').then(m => m.ParentHallModule),
        resolve: { category: HallsService },
      }, {
        path: ':categorySlug',
        data: {
          isCacheable: true,
          toolbarMode: ToolbarMode.transparent,
          isChildComp: true
        },
        loadChildren: () => import('./child-hall/child-hall.module').then(m => m.ChildHallModule),
        resolve: { subCategory: HallsService }
      }, {
        path: ':categorySlug/:subCategorySlug',
        data: {
          isCacheable: true,
          isChildComp: true,
        },
        loadChildren: () => import('./child-hall/child-hall.module')
          .then(m => m.ChildHallModule),
        resolve: { subCategory: HallsService }
      }
    ]

  }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes),
    ],
    exports: [RouterModule],
    providers: [
        HallsService
    ]
})
export class HallRoutingModule { }

